export default function getCreateYear(dateString) {
  const date = new Date(dateString);

  // Extract the year from the Date object
  const year = date.getFullYear();

  return year;
}
